import React, { useState } from 'react';
import { css } from 'emotion';
import { textSans } from '@guardian/src-foundations/typography';
import { text } from '@guardian/src-foundations/palette';
import { stringifyFileBase64 } from '../../lib/stringifyFileBase64';
import { FieldLabel } from './FieldLabel';
const fileUploadInputStyles = css `
    padding-top: 10px;
    padding-bottom: 10px;
`;
const errorMessagesStyles = css `
    padding-bottom: 10px;
    color: ${text.error};
    ${textSans.medium({ fontWeight: 'bold' })};
`;
export const FileUpload = ({ formField, formData, setFormData }) => {
    const [error, setError] = useState('');
    const onSelectFile = async (event) => {
        if (event.target.files && event.target.files[0]) {
            try {
                setError('');
                const stringifiedFile = await stringifyFileBase64(event.target.files[0]);
                setFormData({
                    ...formData,
                    [formField.id]: stringifiedFile,
                });
            }
            catch (e) {
                setError(e);
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FieldLabel, { formField: formField }),
        React.createElement("input", { "data-testid": `form-field-${formField.id}`, className: fileUploadInputStyles, type: "file", accept: "image/*, .pdf", required: formField.required, onChange: onSelectFile }),
        React.createElement("p", null, "We accept images and pdfs. Maximum total file size: 6MB"),
        error && React.createElement("div", { className: errorMessagesStyles }, error)));
};
